import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import StyledCard from 'components/styled-card';
import { NightlyResponse } from 'types/hcp/pdfreport.type';

const SPO = ({ score, nightly }: { score: string; nightly: NightlyResponse }) => {
  const { t } = useTranslation();
  return (
    <StyledCard id="nightly-spo2" title={t('nightly.spo2')}>
      <Row gutter={[16, 16]}>
        <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 14 }} xl={{ span: 12 }}>
          {score === '3' && (
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                {t('nightly.odi3')}
              </Col>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 14 }} xl={{ span: 14 }}>
                {nightly?.variables?.ODI3} {t('events-h')}
              </Col>
            </Row>
          )}
          {score === '4' && (
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                {t('nightly.odi4')}
              </Col>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 14 }} xl={{ span: 14 }}>
                {nightly?.variables?.ODI4} {t('events-h')}
              </Col>
            </Row>
          )}
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 10 }} xl={{ span: 10 }}>
              {t('nightly.t90')}
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 14 }} xl={{ span: 14 }}>
              {Math.round(nightly?.variables?.T90)}%{' '}
              {nightly?.settings?.showT90T ? nightly?.variables?.formattedT90T : ''}
            </Col>
          </Row>
          {nightly?.settings?.showT88 && (
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                {t('nightly.t88')}
              </Col>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 14 }} xl={{ span: 14 }}>
                {Math.round(nightly?.variables?.T88)}% {nightly?.variables?.formattedT88T}
              </Col>
            </Row>
          )}
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 10 }} xl={{ span: 12 }}>
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 16 }} xl={{ span: 12 }}>
              {t('summary.max-spo2')}
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 12 }}>
              {nightly?.variables?.maxSpO2}%
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 16 }} xl={{ span: 12 }}>
              {t('summary.min-spo2')}
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 12 }}>
              {nightly?.variables?.minSpO2}%
            </Col>
          </Row>
          {nightly?.settings?.showBaseSpo2 && (
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 16 }} xl={{ span: 12 }}>
                {t('summary.base-spo2')}
              </Col>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 12 }}>
                {nightly?.variables?.baseSpO2}%
              </Col>
            </Row>
          )}
          {nightly?.settings?.showAvgSpo2 && (
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 16 }} xl={{ span: 12 }}>
                {t('summary.mean-spo2')}
              </Col>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 12 }}>
                {nightly?.variables?.avgSpO2}%
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </StyledCard>
  );
};

export default SPO;
